__turbopack_context__.v({
  "applyBtn": "STCareerDetail-module__YWSRJG__applyBtn",
  "backBtn": "STCareerDetail-module__YWSRJG__backBtn",
  "iconBtn": "STCareerDetail-module__YWSRJG__iconBtn",
  "jobDetailWrapper": "STCareerDetail-module__YWSRJG__jobDetailWrapper",
  "jobList": "STCareerDetail-module__YWSRJG__jobList",
  "sectionTitle": "STCareerDetail-module__YWSRJG__sectionTitle",
});
